export const PRODUCT_TOUR = {
  fabButton: 'product-tour-fab-button',
  inviteCard: 'product-tour-invite-card',
  inviteYesButton: 'product-tour-invite-yes-button',
  inviteNoButton: 'product-tour-invite-no-button',
  inviteCloseButton: 'product-tour-invite-close-button',
};
